var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-modal",
    {
      attrs: { "aria-label": _vm.header, role: "dialog", size: "lg" },
      on: { hide: _vm.close },
      model: {
        value: _vm.opened,
        callback: function ($$v) {
          _vm.opened = $$v
        },
        expression: "opened",
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _c("basic-modal-close-button", { ref: "closeButton" }),
          _vm._v(" "),
          _c("h3", { staticClass: "modal-title" }, [
            _vm._v(_vm._s(_vm.header)),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c(
            "div",
            { staticClass: "hide-goal-option" },
            [
              _c("vue-switch-with-label", {
                staticClass: "hide-goal-switch",
                attrs: {
                  name: "hideGoal",
                  value: _vm.hideGoal,
                  label: _vm.hideGoalLabel,
                },
                on: { input: (val) => (_vm.hideGoal = val) },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "help-text" }, [
            _c("p", [
              _vm._v(
                "You can see the " +
                  _vm._s(_vm._f("customTerm")("Goal")) +
                  " again by clicking the filter and choosing 'show hidden\n                    Goals'."
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "margin-5-top" }, [
              _vm._v(
                "You can make the " +
                  _vm._s(_vm._f("customTerm")("Goal")) +
                  " 'In progress' again by clicking\n                    'mark Goal as In\n                    Progress'"
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row margin-15-top" }, [
        _c("div", { staticClass: "col-sm-12 text-center" }, [
          _c(
            "button",
            {
              staticClass: "btn-mm btn-green btn-mm-big",
              on: { click: _vm.ok },
            },
            [_vm._v("Finish " + _vm._s(_vm._f("customTerm")("Goal")))]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c("div", { staticClass: "row text-left" }, [
          _c("div", { staticClass: "col-xs-12" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-mm btn-default save-button",
                on: {
                  click: function ($event) {
                    return _vm.close("back")
                  },
                },
              },
              [
                _c("i", { staticClass: "far fa-chevron-left" }),
                _vm._v(" back\n                "),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }